import { useState, useEffect, useContext } from "react";
import "./common.scss";
import { currentFormattedDateAndTime, trackEvent } from "../../utils/mixPanel";
import FormRendererContext from "../../services/context/FormRendererContext";
import { isUrl } from "../../utils/generalUtils";

const Email = ({ data, setAnswer, formValidation, formClass }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [validForm, setFormValidation] = useState(formValidation);
  const { answerData, isJourneyReadOnly } = useContext(FormRendererContext);

  useEffect(() => {
    setFormValidation(formValidation);
    if (data?.answer && data?.answer?.value && data?.answer?.value !== "") {
      setSelectedOption(data.answer?.value);
      setFormValidation(true);
    }
    if (answerData?.[data?.key]) {
      setSelectedOption(answerData?.[data?.key]?.value);
    }
  }, [formValidation]);

  const handleFocus = (e) => {
    trackEvent(`email ${data?.label} clicked`, {
      question: data?.label,
      questionKey: data?.key,
      clickedAt: currentFormattedDateAndTime(),
    });
  };
  const handleBlur = (e) => {
    trackEvent(`email ${data?.label} filled`, {
      question: data?.label,
      questionKey: data?.key,
      clickedAt: currentFormattedDateAndTime(),
      // filledValue: selectedOption,
      data: "Answered",
    });
  };

  return (
    <div className={`w-full ${formClass}`}>
      <div className="form-title pt-3">
        {data.label}

        {data?.validate?.required ? (
          <span className={!validForm ? "text-red-700" : ""}> * </span>
        ) : (
          <></>
        )}
      </div>
      <form className="flex-grow">
        <div className="radio-common">
          <label>
            <input
              type="email"
              disabled={data?.disabled || isJourneyReadOnly || false}
              value={selectedOption}
              onChange={(e) => {
                setSelectedOption(e.target.value);
                setAnswer(data, { value: e.target.value });
                setFormValidation(true);
              }}
              onFocus={(e) => {
                handleFocus(e);
              }}
              onBlur={(e) => {
                handleBlur(e);
              }}
              className="text-field text-input"
            />
          </label>
        </div>
      </form>
      {data?.validate?.required && !validForm ? (
        <span className="text-red-700 font-light text-xs">
          {" "}
          Required Field{" "}
        </span>
      ) : (
        <></>
      )}
      {data?.description && (
        <div className="text-xs text-gray-500 leading-relaxed mt-1">
          {isUrl(data.description) ? (
            <img
              src={data.description}
              alt="Description"
              className="mt-1 rounded"
              style={{ maxHeight: "200px" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = "none";
                e.target.parentNode.textContent = data.description;
              }}
            />
          ) : (
            data.description
          )}
        </div>
      )}
    </div>
  );
};
export default Email;
